<template>
  <div class="card-custom-height">
    <div class="w-full h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mt-5px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="项目名称"
          v-model="searchData.projectName"
          clearable
        ></el-input>
        <el-select
          size="small"
          class="mr-10px !w-50"
          placeholder="项目类型"
          v-model="searchData.projectType"
          @change="handleSearch"
          filterable
          clearable
        >
          <el-option
            v-for="item in projectTypeList"
            :key="item.code"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <el-table
        :data="dataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
        <el-table-column
          label="项目编号"
          align="center"
          prop="projectNo"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="项目名称"
          align="center"
          prop="projectName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="合同编号"
          align="center"
          prop="contractNo"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="项目类型" align="center" prop="projectType" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ projectTypeMap(scope.row.projectType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="乙方项目经理"
          align="center"
          prop="projectManager"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          align="center"
          prop="projectManagerContact"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleDetail(scope.row)" v-if="$hasAccess('detail')"
              >查看</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        background
        @size-change="tableSizeChange"
        @current-change="tableCurrentChange"
        :current-page.sync="pageConfig.SkipCount"
        :page-size.sync="pageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="totalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <!-- <div v-if="currentComp === 'DETAIL'" class="w-full h-full">
      <div class="flex justify-between items-center">
        <div class="title text-lg mb-7">
          详情
        </div>
      </div>
      <div class="w-full detail-height">
        <relate-project-detail
          :projectId="projectId"
          @back="checkComponents('TABLE')"
        ></relate-project-detail>
      </div>
    </div> -->
  </div>
</template>

<script>
import { ContractorProjectApi } from '@wiz-api/contractor-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const contractorProjectApi = new ContractorProjectApi()
const dataCategoryApi = new DataCategoryApi()
const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()

export default {
  name: 'RelateProjectInfo',
  props: {
    contractId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      projectTypeList: [],
      currentComp: 'TABLE',
      projectId: '',
      tableLoading: false,
      dataList: [],
      totalCount: 0,
      searchData: {
        contractorId: this.contractId,
        projectName: '',
        projectType: '',
      },
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  created() {
    this.getConfig()
    this.getList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 105px)'
    },
    projectTypeMap() {
      return (val) => {
        return (
          this.projectTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  methods: {
    // 获取数据字典
    async getConfig() {
      let ids = []
      const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
      if (!configError) {
        const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
          codes: [abpConfigList.setting.values['ProjectManagement.DataCategory.ProjectType']],
          includeDetails: true,
        })
        if (!statusError) {
          ids = statusRes.map((item) => {
            return item.id
          })
          this.getItemsByIds(ids)
        }
      }
    },
    // 获取数据字典列表
    async getItemsByIds(ids) {
      const [err, res] = await dataCategoryApi.getListByIds({
        ids,
        includeDetails: true,
      })
      if (!err) {
        // 字典-项目类型
        this.projectTypeList = res.filter((item) => {
          return item.code === 'ProjectType'
        })[0].dataItems
      }
    },
    // 组件切换方法
    checkComponents(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 详情
    async handleDetail(row) {
      this.projectId = row.id
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'DETAIL'
      })
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    // 重置
    handleReset() {
      this.searchData = {
        Type: '',
        ReadStatus: '',
        Title: '',
      }
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 获取消息列表
    async getList() {
      this.tableLoading = true
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      const [err, res] = await contractorProjectApi.relatedProjectPageList(data)
      if (!err) {
        this.dataList = res.items
        this.totalCount = res.totalCount
      }
      this.tableLoading = false
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}

.detail-height {
  height: calc(100% - 52px);
}

.card-custom-height {
  height: calc(100% - 50px);
}
</style>
